import React, {Component} from 'react';
import { Table } from 'antd';

class PaginatedList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {}
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (!nextProps.location.search) {
            return {pagination: {...prevState.pagination, current: 1}};
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.pagination.current !== prevState.pagination.current){
            this.props.fetchData(this.state.pagination.current);
        }
    }
    componentDidMount() {
        const {fetchData, location: {search}} = this.props;
        const [full, page] = search.match(/page=(\d+)/) || ['', 1];
        return fetchData(page).then(() => {
            const {current_page: current  = page, per_page: pageSize = 15, total = 100} = this.props.meta;
            this.setState({pagination: {
                current,
                total,
                pageSize
            }});
        });
    }
    handleTableChange(pagination) {
        const { history, match: {url}} = this.props;
        const {current} = pagination;
        this.setState({pagination: {...this.state.pagination, current}}, () => {
            history.push(`${url}?page=${current}`)
        });
    }
    render() {
        const {source, columns, loading} = this.props;

        return (
            <Table
                columns={columns}
                dataSource={source}
                loading={loading}
                pagination={this.state.pagination}
                rowKey={record => record.id}
                size="middle"
                onChange={this.handleTableChange.bind(this)}
            />
        );
    }
}
export default PaginatedList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/PaginatedList.js